<div class="container chart" [ngClass]="customeClass">
  <canvas [attr.id]="chartId"></canvas>
</div>
